/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMaterial } from './APIMaterial';
import {
    APIMaterialFromJSON,
    APIMaterialFromJSONTyped,
    APIMaterialToJSON,
} from './APIMaterial';

/**
 * 
 * @export
 * @interface APIPaginatedMaterialList
 */
export interface APIPaginatedMaterialList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedMaterialList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedMaterialList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedMaterialList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIMaterial>}
     * @memberof APIPaginatedMaterialList
     */
    results: Array<APIMaterial>;
}

/**
 * Check if a given object implements the APIPaginatedMaterialList interface.
 */
export function instanceOfAPIPaginatedMaterialList(value: object): value is APIPaginatedMaterialList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedMaterialListFromJSON(json: any): APIPaginatedMaterialList {
    return APIPaginatedMaterialListFromJSONTyped(json, false);
}

export function APIPaginatedMaterialListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedMaterialList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIMaterialFromJSON)),
    };
}

export function APIPaginatedMaterialListToJSON(value?: APIPaginatedMaterialList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIMaterialToJSON)),
    };
}

